import { Component } from '@angular/core';
import { QueryService } from '../services/query.service';
import { ProductosService } from '../services/productos.service';

// Interfaz para la estructura agrupada
interface GrupoAnio {
  anio: string;
  totalAnio: number;
  meses: any[]; // Aquí van tus registros originales de 'compras'
}

@Component({
  selector: 'app-compras',
  templateUrl: './compras.component.html',
  styleUrl: './compras.component.css'
})
export class ComprasComponent {
  compras: any[] = [];
  comprasAgrupadas: GrupoAnio[] = [];

  constructor(private query: QueryService, public productosService: ProductosService) { }

  ngOnInit() {
    this.query
      .query('compras', 'GET', null)
      .subscribe((resultado: any) => {
        this.compras = resultado.registros;
        this.agruparPorAnio();
      });
  }

  togglePanel(compra: any): void {
    this.getComprasMes(compra);
    compra.panelAbierto = !compra.panelAbierto;
  }
  togglePanelCompra(compra: any): void {
    this.getProductosCompra(compra);
    compra.panelAbierto = !compra.panelAbierto;
  }

  getComprasMes(compra: any) {
    compra.busy = true;
    this.query
      .query('compras', 'GETMES', compra)
      .subscribe((resultado: any) => {
        compra.compras = resultado.registros;
        compra.busy = false;
      });
  }

  getProductosCompra(compra: any) {
    compra.busy = true;
    this.query
      .query('compras', 'GETPRODUCTOS', compra)
      .subscribe((resultado: any) => {
        compra.productos = resultado.registros;
        compra.busy = false;
      });
  }

  // Función para procesar los datos que recibes de la base de datos/API
  agruparPorAnio() {
    const mapa = this.compras.reduce((acc, compra) => {
      const anio = compra.aniomes.toString().substring(0, 4); 

      if (!acc[anio]) {
        acc[anio] = { anio: anio, totalAnio: 0, meses: [] };
      }
      
      acc[anio].meses.push(compra);
      
      // 🔴 LA SOLUCIÓN: Forzamos a que sea un número antes de sumar
      acc[anio].totalAnio += Number(compra.total) || 0; 
      
      return acc;
    }, {});

    this.comprasAgrupadas = (Object.values(mapa) as GrupoAnio[]).sort((a, b) => Number(b.anio) - Number(a.anio));
  }

  volver() {
    this.productosService.vista = 'P';
  }

}